import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "../lib/api";
import { WAITLIST } from "../constants/testIds";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | ok | err

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/waitlist", { email, source: "footer" });
      setState("ok");
      setEmail("");
    } catch { setState("err"); }
  };

  return (
    <footer className="bg-ink text-bone mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-28 pb-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14">
          <div className="md:col-span-6">
            <p className="text-[10px] uppercase tracking-eyebrow text-bone/60">Correspondence</p>
            <h3 className="font-serif-display text-4xl md:text-6xl leading-[1.02] mt-6 max-w-[16ch]">
              Slow letters. On the house, its work, and what is next.
            </h3>
            <form onSubmit={submit} className="mt-10 max-w-md flex items-end gap-6">
              <input
                data-testid={WAITLIST.input}
                type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                placeholder="Your address"
                className="field !border-bone/40 !text-bone placeholder:!text-bone/40"
              />
              <button data-testid={WAITLIST.submit} className="text-[11px] uppercase tracking-editorial pb-3 border-b border-bone/60 hover:border-bone">
                Subscribe
              </button>
            </form>
            {state === "ok" && <p className="mt-4 text-[11px] tracking-editorial uppercase text-bone/70">Received. Welcome.</p>}
            {state === "err" && <p className="mt-4 text-[11px] tracking-editorial uppercase text-bone/70">A quiet issue. Kindly try again.</p>}
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-eyebrow text-bone/50 mb-6">Index</p>
            <ul className="space-y-3 text-[13px] text-bone/85">
              <li><Link to="/collection">The Collection</Link></li>
              <li><Link to="/rituals">Deux Rituels</Link></li>
              <li><Link to="/house">The House</Link></li>
              <li><Link to="/journal">Journal</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-eyebrow text-bone/50 mb-6">Services</p>
            <ul className="space-y-3 text-[13px] text-bone/85">
              <li>Private appointments</li>
              <li>Press &amp; partnerships</li>
              <li>Wholesale enquiries</li>
              <li>Care &amp; returns</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-eyebrow text-bone/50 mb-6">Maisons</p>
            <ul className="space-y-3 text-[13px] text-bone/85">
              <li>1236 Keydet Dr · Charlotte</li>
              <li>24 Redchurch St. · London</li>
              <li>12 Osu Ave. · Accra</li>
            </ul>
          </div>
        </div>

        <div className="mt-24 flex items-end justify-between gap-8">
          <div className="font-serif-display text-[18vw] leading-none text-bone/90 select-none">korv<span className="text-plum">.</span></div>
        </div>

        <div className="hairline-soft mt-14 !bg-bone/25" />
        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] tracking-editorial uppercase text-bone/55">
          <span>© House of Korv. All work reserved.</span>
          <span>Established quietly, MMXXV.</span>
          <span>Privacy · Terms · Accessibility</span>
        </div>
      </div>
    </footer>
  );
}
